// removed by extract-text-webpack-plugin
module.exports = {"form":"_3ILaNSG","email":"_1hJLuN8","button":"_2w_mHpG","privacy":"_2nYSc26","privacyLink":"A0qpV-d","messageContainer":"_3xcPoIw","message":"_2exv2Bs","createdIcon":"_3twIzCo","createdSvg":"LhpNCZx"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMailOld/JobMail.less
 ** module id = 886
 ** module chunks = 0
 **/